import React from "react";
import "./Slide.css";

export default function Slide({
  bg = "/slide.jpg",
  title = "Đồng bằng sông Mekong",
  desc = `Chào mừng đến với Đồng bằng sông Mekong, một vùng đất giàu văn hóa và vẻ đẹp thiên nhiên.
Tham gia tour tham quan trong ngày của chúng tôi để khám phá các chợ địa phương và tận hưởng khung cảnh sông nước thơ mộng.
Thưởng thức ẩm thực truyền thống và tìm hiểu về cuộc sống thường nhật ở vùng đất hấp dẫn này của Việt Nam.`,
  ctaText = "Thông tin",
  onCta,
  ctaHref = "#info",
}) {
  return (
    <section
      className="mk-hero"
      style={{ "--mk-bg": `url(${bg})` }}
      aria-label="Mekong Hero"
    >
      <div className="mk-overlay" />

      <div className="mk-wrap">
        <div className="mk-content">
          <h1 className="mk-title">{title}</h1>
          <p className="mk-desc">{desc}</p>

          {onCta ? (
            <button className="mk-btn" onClick={onCta} type="button">
              {ctaText}
            </button>
          ) : (
            <a className="mk-btn" href={ctaHref}>
              {ctaText}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}